import * as style from '../../utils/general_style.js';

function SubmitButton({ label }) {
    const backgroundStyle = {
        width: '280px',
        height: '40px',
        border: 'none',
        borderRadius: '20px',
        backgroundColor: style.COLORS.secondary,
        color: style.COLORS.white,
        cursor: 'pointer'
    };

	return (
        <button type="submit" style={{...style.COLUMN_CENTER, ...backgroundStyle}}>
            <p>{label}</p>
		</button>
	);
};

export default SubmitButton;